/*
 * @Author: zjt
 * @Email: 13928932429@163.com
 * @Date: 2020-08-06 16:48:27
 * @LastEditTime: 2020-08-12 22:17:17
 * @Description: 复配中心api
 */
import axios from '@/utils/axios'

export const getSacsList = (payload) => {
    return axios.get('/sac', {
        params: payload
    })
}

export const getSacById = (id) => {
    return axios.get(`/sac/${id}`)
}

export const updateSac = (id, data) => {
    return axios.put(`/sac/${id}`, data);
}

export const createSac = (data) => {
    return axios.post(`/sac`, data)
}

export const deleteSac = (id) => {
    return axios.delete(`/sac/${id}`)
}

export const createSacSales = (data) => {
    return axios.post(`/sacSales`, data)
}

export const updateSacSales = (id, data) => {
    return axios.put(`/sacSales/${id}`, data);
}

export const createSacRecipe = (data) => {
    return axios.post(`/sacRecipe`, data)
}

export const updateSacRecipe = (id, data) => {
    return axios.put(`/sacRecipe/${id}`, data);
}

export const getSacRecipeList = (payload) => {
    return axios.get('/sacRecipe', {
        params: payload
    })
}